import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import { EventDateSelection } from './eventdateselection';
import { EventInfoModelShape } from './types';
import { EventDateInfo } from '../../../mvcapi/models/common';
import { checkHasSameVenueNames, getEventDateDisplayMode } from '../../../logic/sales-util';

// Uses window.tsapp
const tr = require('ts-translate-js').default.boundTR;

const getPrefixedVenueName = (venueName) => {
    let pref = "";

    // Mappings (In a function so the translation is dynamic and not only on load of the file)
    if(venueName === "Théâtre Marcellin-Champagnat") pref = tr("Au");
    else if(venueName === "Salle André-Mathieu") pref = tr("A la");

    return pref + " " + venueName;
};

interface EventInfoProps {
    eventID: number,
    eventDateInfos: EventDateInfo[],
    selectedEventDate: EventDateInfo,
    onContentChange: () => void,
    onChangeEventDate: (eventDateInfo: EventDateInfo) => void,
    //onModifyThisStep: () => void, // Called when the user want to come back to this step
    onBuyClick: () => void,
    loadingProductInfo: boolean,
    onMembershipPresaleClick: (membershipTypeID: number, isInMembershipCardPreSaleAndHaveValidCard: boolean) => void,
    onPromoUpdated: (promoCode: string) => void,
    hiddenPromo: boolean,
    integ: string
}

export const EventInfo = createClass<EventInfoProps>({
    displayName: "EventInfo",

    propTypes: {
        eventID: PropTypes.number,
        eventDateInfos: PropTypes.arrayOf(EventInfoModelShape),
        selectedEventDate: EventInfoModelShape,
        onContentChange: PropTypes.func,
        onChangeEventDate: PropTypes.func,
        //onModifyThisStep: PropTypes.func, // Called when the user want to come back to this step
        onBuyClick: PropTypes.func,
        loadingProductInfo: PropTypes.bool,
        onMembershipPresaleClick: PropTypes.func,
        onPromoUpdated: PropTypes.func,
        hiddenPromo: PropTypes.bool
    },

    componentDidMount: function() {
        this.raiseContentChanged();
    },

    componentDidUpdate: function () {
        this.raiseContentChanged();
    },

    raiseContentChanged() {
        // Set timeout because even though React rendered the tags, they are not yet drawn on the screen.
        setTimeout(function(){
            if(this.props.onContentChange !== undefined) this.props.onContentChange();
        }.bind(this), 0);
    },

    handleOnChangeEventDate(eventDateInfo: EventDateInfo, triggerBuy = false) {
        if(this.props.onChangeEventDate != undefined)
            this.props.onChangeEventDate(eventDateInfo, triggerBuy);
    },

    handleOnBuyClick: function() {
        if(this.props.onBuyClick !== undefined) this.props.onBuyClick();
    },

    render() {
        let content = null;

        const isDisplayModeCombo = getEventDateDisplayMode(this.props.eventDateInfos) == "combo";

        if(this.props.eventDateInfos != null) {
            if(this.props.eventDateInfos.length > 0) {
                content = (
                    <EventDateSelection
                        eventDateInfos={this.props.eventDateInfos}
                        selectedEventDate={isDisplayModeCombo ? this.props.selectedEventDate : null}
                        onContentChange={this.props.onContentChange}
                        onBuyClick={this.handleOnBuyClick}
                        onChangeEventDate={this.handleOnChangeEventDate}
                        //onModifyThisStep={this.props.onModifyThisStep}
                        loadingProductInfo={this.props.loadingProductInfo}
                        onPromoUpdated={this.props.onPromoUpdated}
                        hiddenPromo={this.props.hiddenPromo}
                        onMembershipPresaleClick={this.props.onMembershipPresaleClick}
                        integ={this.props.integ}
                    />
                );
            } else {
                content = <div className="alert alert-warning"><strong>{tr("Aucune date disponible")}</strong></div>;
            }

        } else {
            content = <h4><strong>{tr("Chargement des dates en cours...")}</strong></h4>;
        }


        let venueName;
        if(this.props.selectedEventDate != null && checkHasSameVenueNames(this.props.eventDateInfos)) {
            venueName = (
                <div className="row">
                    <p className="col-xs-12 text-center">
                        {getPrefixedVenueName(this.props.selectedEventDate.VenueName)}
                    </p>
                </div>
            );
        }

        // TODO: Change that program-info-widget
        return (
            <div className="event-info-widget">
                {content}
                {venueName}
            </div>
        );
    }

});